export default __webpack_public_path__ + "7c1dfde462c7d85b76cda2081fd51db3.svg";